import React from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { DetailReadOnlyField } from '../components/DetailFields';
import { DetailFieldRow, DetailValue } from '../components/DetailFields';
import { detailGrid2 } from '../storeDetailsConstants';
import {
  formatCurrency,
  formatDateTime,
  formatDetailValue,
} from '../storeDetailsUtils';

export function DeliverySection({ meta, store }) {
  const op = store?.kitchen_operation ?? {};
  const shortage = op.delivery_driver_shortage ?? {};
  const logs = Array.isArray(shortage.logs) ? shortage.logs : [];
  const agreementFees = Array.isArray(op.delivery_agreement_fees) ? op.delivery_agreement_fees : [];

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <div style={detailGrid2}>
        <DetailReadOnlyField
          label="Subscription delivery fee"
          value={formatCurrency(op.deliverySubscription_fee)}
        />
        <DetailReadOnlyField
          label="Pay-as-you-go delivery fee"
          value={formatCurrency(op.deliveryPayAsYouGo_fee)}
        />
        <DetailReadOnlyField
          label="Free pay-as-you-go delivery"
          value={op.freePayAsYouGoDelivery ? 'Yes' : 'No'}
        />
        <DetailReadOnlyField
          label="Pay-as-you-go time gap (min)"
          value={formatDetailValue(op.freePayAsYouGoDelivery_TimeGap)}
        />
        <DetailReadOnlyField
          label="Free subscription delivery"
          value={op.freeSubscriptionDelivery ? 'Yes' : 'No'}
        />
        <DetailReadOnlyField
          label="Subscription time gap (min)"
          value={formatDetailValue(op.freeSubscriptionDelivery_TimeGap)}
        />
        <DetailReadOnlyField
          label="Delivery agreement fees"
          value={agreementFees.length ? `${agreementFees.length} configured` : 'None'}
        />
      </div>

      <div style={{ marginTop: 20 }}>
        <DetailFieldRow
          label="Driver shortage"
          description="Current delivery driver availability for this store"
        >
          <DetailValue>{shortage.driver_shortage ? 'Yes' : 'No'}</DetailValue>
        </DetailFieldRow>
        <div style={detailGrid2}>
          <DetailReadOnlyField label="Updated by user type" value={shortage.user_type} />
          <DetailReadOnlyField label="Updated by user" value={shortage.user_name} />
        </div>
      </div>

      {logs.length > 0 ? (
        <div style={{ marginTop: 16 }}>
          <div className="store-details-list-block">
            <div className="store-details-list-block__title">Driver shortage history</div>
            {logs.map((log) => (
              <div key={log._id || log.update_time} className="store-details-log-row">
                <span>{log.driver_shortage ? 'Shortage' : 'No shortage'}</span>
                <span style={{ color: '#6b7280', fontSize: 12 }}>
                  {log.user_name} · {formatDateTime(log.update_time)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
}
